import { useCallback, useEffect, useRef, useState } from 'react';

const IDLE_TIMEOUT_MS = 4000;

/**
 * Keeps call overlays (header, controls) out of the way of the video: they show
 * on interaction and fade back out once the screen has been left alone.
 */
export default function useOverlayVisibility(idleTimeoutMs: number = IDLE_TIMEOUT_MS) {
  const [isVisible, setIsVisible] = useState(true);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const reveal = useCallback(() => {
    setIsVisible(true);
    clearTimeout(hideTimer.current);
    hideTimer.current = setTimeout(() => setIsVisible(false), idleTimeoutMs);
  }, [idleTimeoutMs]);

  useEffect(function hideAfterInitialIdle() {
    reveal();
    return () => clearTimeout(hideTimer.current);
  }, [reveal]);

  return { isVisible, reveal };
}
